"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NmlsLienPosition = exports.NmlsMortgageLicenseCategory = exports.NmlsRegulatorAgency = exports.NmlsFederalRegistrationStatus = exports.NmlsIdType = void 0;
var NmlsIdType;
(function (NmlsIdType) {
    NmlsIdType["Company"] = "Company";
    NmlsIdType["Branch"] = "Branch";
    NmlsIdType["Individual"] = "Individual";
})(NmlsIdType || (exports.NmlsIdType = NmlsIdType = {}));
/**
 * Status of a company's federal registration in NMLS. Values match the NMLS_COMPANY.REGISTRATIONSTATUS
 * strings verbatim. A company with no federal registration has NULL here (not a member of this enum).
 */
var NmlsFederalRegistrationStatus;
(function (NmlsFederalRegistrationStatus) {
    NmlsFederalRegistrationStatus["Active"] = "Active";
    NmlsFederalRegistrationStatus["Inactive"] = "Inactive";
})(NmlsFederalRegistrationStatus || (exports.NmlsFederalRegistrationStatus = NmlsFederalRegistrationStatus = {}));
/**
 * State regulatory agency that issued/oversees a license, parsed from NMLS's `Regulator` free text
 * (e.g. "California - DFPI"). UNKNOWN = an agency suffix was present but isn't a recognized code.
 */
var NmlsRegulatorAgency;
(function (NmlsRegulatorAgency) {
    /** Alabama Securities Commission */
    NmlsRegulatorAgency["SC"] = "SC";
    /** California Department of Financial Protection and Innovation */
    NmlsRegulatorAgency["DFPI"] = "DFPI";
    /** California / Utah Department of Real Estate */
    NmlsRegulatorAgency["DRE"] = "DRE";
    /** Department of Banking (Colorado, Oklahoma, Texas) */
    NmlsRegulatorAgency["DOB"] = "DOB";
    /** Department of Financial Institutions (Indiana, Utah) */
    NmlsRegulatorAgency["DFI"] = "DFI";
    /** Secretary of State (Indiana, Nebraska) */
    NmlsRegulatorAgency["SOS"] = "SOS";
    /** Nevada Financial Institutions Division */
    NmlsRegulatorAgency["FID"] = "FID";
    /** South Carolina Attorney General */
    NmlsRegulatorAgency["AG"] = "AG";
    /** South Carolina Board of Financial Institutions */
    NmlsRegulatorAgency["BFI"] = "BFI";
    /** South Carolina Department of Consumer Affairs */
    NmlsRegulatorAgency["DCA"] = "DCA";
    /** Texas Office of Consumer Credit Commissioner */
    NmlsRegulatorAgency["OCCC"] = "OCCC";
    /** Texas Department of Savings and Mortgage Lending */
    NmlsRegulatorAgency["SML"] = "SML";
    /** An agency suffix was present in the NMLS `Regulator` string but is not a recognized code. */
    NmlsRegulatorAgency["UNKNOWN"] = "UNKNOWN";
})(NmlsRegulatorAgency || (exports.NmlsRegulatorAgency = NmlsRegulatorAgency = {}));
/**
 * Broad classification of a raw NMLS license-type string by the residential-mortgage authority it grants.
 *
 * State-agnostic: this classifies the license *string* only. Question of if license authorizes LO activity
 * is dealt with by caller.
 */
var NmlsMortgageLicenseCategory;
(function (NmlsMortgageLicenseCategory) {
    /** Authority to make/fund residential mortgages: banker, lender, mortgage company/entity, correspondent. */
    NmlsMortgageLicenseCategory["LENDER"] = "LENDER";
    /** Authority to broker/arrange residential mortgages (does not fund): mortgage broker/brokerage/processor. */
    NmlsMortgageLicenseCategory["BROKER"] = "BROKER";
    /** A single license granting both lending and brokering authority (e.g. "Mortgage Broker/Lender License"). */
    NmlsMortgageLicenseCategory["LENDER_AND_BROKER"] = "LENDER_AND_BROKER";
    /** An individual's origination authority: the "Mortgage Loan Originator License" (NMLS MU4). */
    NmlsMortgageLicenseCategory["ORIGINATOR"] = "ORIGINATOR";
    /** An individual origination license whose authority is narrower than a plain MLO license. */
    NmlsMortgageLicenseCategory["RESTRICTED_ORIGINATOR"] = "RESTRICTED_ORIGINATOR";
    /**
     * Consumer / installment / supervised lender. May cover mortgages under a consumer-credit statute,
     * but that is state-dependent — a weak signal, kept distinct so the consumer can decide.
     */
    NmlsMortgageLicenseCategory["CONSUMER_INSTALLMENT_LENDER"] = "CONSUMER_INSTALLMENT_LENDER";
    /**
     * Not residential-mortgage authority: servicing-only, MLO-endorsement-only, exemptions, commercial or
     * reverse mortgage, check cashing, money transmission, debt collection, escrow, etc.
     */
    NmlsMortgageLicenseCategory["OTHER"] = "OTHER";
})(NmlsMortgageLicenseCategory || (exports.NmlsMortgageLicenseCategory = NmlsMortgageLicenseCategory = {}));
/**
 * Lien position explicitly named in a license-type string. Only a few states split licenses by lien
 * (Michigan "1st/2nd Mortgage *", Pennsylvania "First Mortgage Banker"/"Second Mortgage Lender", Utah).
 *
 * Validity requires coverage of BOTH liens. The caller aggregates across all licenses for a
 * (state, brokerage) pair: valid when any license is NOT_SPECIFIED, or when FIRST + SECOND are
 * both present. A single lien-restricted license alone is insufficient.
 */
var NmlsLienPosition;
(function (NmlsLienPosition) {
    NmlsLienPosition["FIRST"] = "FIRST";
    NmlsLienPosition["SECOND"] = "SECOND";
    /** The license-type string names no lien position; presumptively covers both. */
    NmlsLienPosition["NOT_SPECIFIED"] = "NOT_SPECIFIED";
})(NmlsLienPosition || (exports.NmlsLienPosition = NmlsLienPosition = {}));
